import { render, staticRenderFns } from "./checkEditorFootPressure.vue?vue&type=template&id=fb2d88e0&scoped=true&"
import script from "./checkEditorFootPressure.vue?vue&type=script&lang=js&"
export * from "./checkEditorFootPressure.vue?vue&type=script&lang=js&"
import style0 from "./checkEditorFootPressure.vue?vue&type=style&index=0&id=fb2d88e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2d88e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb2d88e0')) {
      api.createRecord('fb2d88e0', component.options)
    } else {
      api.reload('fb2d88e0', component.options)
    }
    module.hot.accept("./checkEditorFootPressure.vue?vue&type=template&id=fb2d88e0&scoped=true&", function () {
      api.rerender('fb2d88e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkEditorFootPressure.vue"
export default component.exports